import { render, staticRenderFns } from "./onlineExamStatistics.vue?vue&type=template&id=22fbf34c&scoped=true"
import script from "./onlineExamStatistics.vue?vue&type=script&lang=js"
export * from "./onlineExamStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbf34c",
  null
  
)

export default component.exports